// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__3NDiU","copyright":"Footer_copyright__1cKzb"};